import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyBldUaHcNxMv3a_TYZN8D7fR4MBbQALo7Y",
    authDomain: "vacctrack-7b327.firebaseapp.com",
    projectId: "vacctrack-7b327",
    storageBucket: "vacctrack-7b327.appspot.com",
    messagingSenderId: "270838149796",
    appId: "1:270838149796:web:62eea0cec32b70a253ac31",
    measurementId: "G-TEB732Y17H"
  };
  // Initialize Firebase
  firebase.initializeApp(config);

  export default firebase;